import { useState } from "react";
import "./LeadPopup.css";

/* ── Contact Form ───────────────────────────────────────── */
function ContactForm({ onSubmit, loading, onClose, defaults, c2aEvent }) {
  const [fullName, setFullName] = useState("");
  const [phone, setPhone] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!fullName.trim()) return alert("Please enter your name");
    if (!/^\d{10}$/.test(phone))
      return alert("Enter a valid 10-digit number");

    // ✅ Only pass user-entered fields — project/location/c2aEvent are
    //    handled inside useLeadForm via formDefaults (Backend table values).
    //    Do NOT pass them here to avoid accidental override.
    onSubmit({
      fullName,
      phone,
      email: "",
    });
  };

  // ✅ Show the button label (c2aEvent) in the title when it's not the
  //    generic auto-popup so users see context-aware headings.
  const titleMap = {
    "Download Brochure":  "Download Brochure",
    "Book Site Visit":    "Book a Site Visit",
    "Get Best Price":     "Get Best Price",
    "Know More":          "Know More",
    "Get More Details":   "Get More Details",
    "Download Payment Plan": "Download Payment Plan",
  };
  const popupTitle = titleMap[c2aEvent] || "Know Floor Plan & Offers Now";

  return (
    <div className="popup-overlay" role="dialog" aria-modal="true">
      <div className="popup-box">
        <button className="popup-close" onClick={onClose} aria-label="Close">×</button>

        <h2 className="popup-title">{popupTitle}</h2>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Full Name *"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            className="popup-input"
          />

          <input
            type="tel"
            placeholder="WhatsApp Number *"
            value={phone}
            onChange={(e) =>
              setPhone(e.target.value.replace(/\D/g, "").slice(0, 10))
            }
            className="popup-input"
          />

          <button className="popup-submit" disabled={loading}>
            {loading ? "Sending OTP…" : "Submit"}
          </button>
        </form>

        <p className="popup-note">100% Privacy | No Brokerage</p>
      </div>
    </div>
  );
}

/* ── OTP Form ───────────────────────────────────────────── */
function OtpForm({
  phone,
  onVerify,
  onResend,
  loading,
  error,
  countdown,
  onBack,
  onClose,
}) {
  const [otp, setOtp] = useState("");

  return (
    <div className="popup-overlay">
      <div className="popup-box">
        <button className="popup-close" onClick={onClose} aria-label="Close">×</button>

        <h2 className="popup-title">Verify OTP</h2>
        <p className="popup-note">OTP sent to +91 {phone || ""}</p>

        <input
          type="text"
          placeholder="Enter OTP"
          value={otp}
          onChange={(e) =>
            setOtp(e.target.value.replace(/\D/g, "").slice(0, 4))
          }
          className="popup-input"
        />

        {error && <p className="popup-error">{error}</p>}

        {countdown > 0 ? (
          <p className="popup-note">Resend in {countdown}s</p>
        ) : (
          <button onClick={onResend} disabled={loading} className="popup-resend">
            Resend OTP
          </button>
        )}

        <button
          className="popup-submit"
          onClick={() => otp.length === 4 && onVerify(otp)}
          disabled={otp.length !== 4 || loading}
        >
          {loading ? "Verifying…" : "Verify & Submit"}
        </button>

        <button className="popup-back" onClick={onBack}>
          ← Back
        </button>
      </div>
    </div>
  );
}

/* ── Thank You ─────────────────────────────────────────── */
function ThankYouPopup({ onClose }) {
  return (
    <div className="popup-overlay">
      <div className="popup-box popup-box--thanks">
        <button className="popup-close" onClick={onClose} aria-label="Close">×</button>

        <h2 className="popup-title">Thank You!</h2>
        <p className="popup-note">
          Your form has been submitted. We'll contact you shortly.
        </p>
      </div>
    </div>
  );
}

/* ── Already Submitted ─────────────────────────────────── */
function AlreadyPopup({ onClose }) {
  return (
    <div className="popup-overlay">
      <div className="popup-box popup-box--thanks">
        <button className="popup-close" onClick={onClose} aria-label="Close">×</button>

        <h2 className="popup-title">Already Submitted</h2>
        <p className="popup-note">
          Your form is already submitted. We'll connect with you shortly.
        </p>

        <button className="popup-submit" onClick={onClose}>
          OK
        </button>
      </div>
    </div>
  );
}

/* ── MAIN COMPONENT ───────────────────────────────────── */
export default function LeadPopup({ leadForm }) {
  const {
    modal,
    loading,
    otpError,
    resendCountdown,
    closeAll,
    handleSendOtp,
    handleVerifyOtp,
    handleResendOtp,
    formData,
    formDefaults,   // ✅ FIX: now correctly exposed from useLeadForm return value
    c2aEvent,       // ✅ FIX: the button label that triggered the popup
  } = leadForm;

  if (modal === "closed") return null;

  if (modal === "thankyou") {
    return <ThankYouPopup onClose={closeAll} />;
  }

  if (modal === "already") {
    return <AlreadyPopup onClose={closeAll} />;
  }

  if (modal === "otp") {
    return (
      <OtpForm
        phone={formData?.phone}
        onVerify={handleVerifyOtp}
        onResend={handleResendOtp}
        loading={loading}
        error={otpError}
        countdown={resendCountdown}
        onBack={() => window.location.reload()}
        onClose={closeAll}
      />
    );
  }

  // modal === "contact"
  return (
    <ContactForm
      onSubmit={handleSendOtp}
      loading={loading}
      onClose={closeAll}
      defaults={formDefaults}   // ✅ FIX: from useLeadForm (Backend table values)
      c2aEvent={c2aEvent}       // ✅ FIX: drives the popup title
    />
  );
}